import type React from "react";

export interface Box {
  x: number;
  y: number;
  w: number;
  h: number;
}

/** When a piece of a tour picture starts, counted from the card's arrival. */
export const delay = (ms: number) =>
  ({ "--og-delay": `${ms}ms` }) as React.CSSProperties;

/** A stroke that draws itself: dashed to its own length, the dash slid in. */
export const traced = (length: number, ms: number) =>
  ({ "--og-delay": `${ms}ms`, "--og-len": length }) as React.CSSProperties;

export const perimeter = (w: number, h: number) => 2 * (w + h);

/** Plays from `at` for `ms`, in place of the class's own timing. */
export const timed = (at: number, ms?: number): React.CSSProperties => ({
  animationDelay: `${at}ms`,
  ...(ms === undefined ? {} : { animationDuration: `${ms}ms` }),
});

/** The CSS transform that lays `to` over `from`, about the picture's origin. */
export const laidOver = (from: Box, to: Box): string => {
  const sx = from.w / to.w;
  const sy = from.h / to.h;
  return `translate(${from.x - to.x * sx}px, ${from.y - to.y * sy}px) scale(${sx}, ${sy})`;
};

/** Custom properties for an element's style. */
export const vars = (values: Record<string, string>) =>
  values as React.CSSProperties;
